var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"height":"400"}},[(_vm.saleUninitiated)?_c('div',{staticClass:"container-div"},[_c('span',{staticClass:"checkout-h3"},[_vm._v(_vm._s(_vm.saleUninitiated))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }